import { b2x } from '@b2x/react/src';

import { IconName, IconSize } from './Icon';

export type AlertFromDtoProps = b2x.AlertFromDtoProps<IconName, IconSize>;

export const AlertFromDto = (props: AlertFromDtoProps) => <b2x.AlertFromDto {...props} />;
